import { render, staticRenderFns } from "./editTag.vue?vue&type=template&id=fe2ef064&scoped=true"
import script from "./editTag.vue?vue&type=script&lang=js"
export * from "./editTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe2ef064",
  null
  
)

export default component.exports